export default "__VITE_ASSET__cdcc2796__"